import React from 'react';

const groups = [
  ['Frontend', ['React.js', 'Next.js', 'JavaScript ES6+', 'TypeScript', 'Redux', 'HTML5', 'CSS3', 'Tailwind CSS', 'Material UI']],
  ['Backend & data', ['Node.js', 'Express.js', 'ASP.NET Web API', 'REST', 'GraphQL', 'Webhooks', 'MongoDB', 'PostgreSQL', 'SQL Server']],
  ['Quality & delivery', ['Jest', 'React Testing Library', 'Supertest', 'AWS EC2 / S3', 'Docker', 'CI/CD', 'Git', 'Swagger', 'Agile / Scrum']],
  ['Architecture', ['OOP', 'Design Patterns', 'Microservices', 'Performance', 'Security Practices', 'Reusable Systems', 'AI-assisted Development']]
];

export default function Skill() {
  return <section className="section skills" id="Skill">
    <div className="section__head"><span className="section__number">04</span><p className="eyebrow">TOOLKIT</p><h2>Built for the whole product lifecycle.</h2></div>
    <div className="skills__grid">{groups.map(([title, items], i) => <article key={title}><div className="skills__title"><span>0{i + 1}</span><h3>{title}</h3></div><div className="skills__tags">{items.map(item => <span key={item}>{item}</span>)}</div></article>)}</div>
  </section>;
}
